import { combineReducers } from 'redux';
import { outboundHandlerReducer } from './OutboundHandlerReducer';
import { handlerReducer } from './HandlerReducer';

export default combineReducers({
  outbound: outboundHandlerReducer,
  handler: handlerReducer,
});
